import React, { useEffect } from 'react';
import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

function TransactionUnsuccessfull(props) {
   
    const dispatch = useDispatch();
    const location = useLocation();
    const id = props.location.state.id;
    const transactionId = props.location.state.failedReferenceNumber;
    const reason=props.location.state.statusMessage;
    const billedData = useSelector(state => state.billed.billedPo);
    const load = billedData.loads.find(load => load.load_id === id);
    const currentdate=new Date()
    const date = currentdate.getFullYear() + '-' + (currentdate.getMonth() + 1) + '-' + currentdate.getDate();

    useEffect(() => {
        dispatch(clearError());
    }, []);

    return (
        <div class="content-page">
            <div class="content">
                <div class="contest_input_block">
                    <div class="contest_preview">
                        <div class="top_header_bar">
                            <div class="row">
                                <div class="col-sm col-xl-4 d-flex align-items-center p-0">
                                    <h3 class="m-0 h3-heading text-danger" title="Transaction Failed"> Transaction Failed <br />
                                        <span class="text-danger" style={{ fontSize: '14px', fontWeight: '400' }}>
                                            {date}</span></h3>
                                </div>
                            </div>
                        </div>

                        <div class="container_block" style={{ padding: '20px' }}>
                            <div class="row">
                                <div class="col-sm-12 col-xxl-12">
                                    <div class="row">
                                        <div class="form-group col-sm-12">
                                            <p style={{ color: '#D54929' }}>There's a technical issue at your bank. Please try after some time.</p>
                                        </div>
                                        <div class="form-group col-sm-12">
                                            <p><strong style={{ color: '#D54929' }}>NOTE:-</strong> if you require assistance ,
                                                Please Contact our Support Contact Center (855) 752-2878.
                                                {/* <Link to='/help'>Click Here</Link></p> */}
                                                </p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-sm-6">
                                        <span class="gray_label">Reason</span>
                                            <p>{reason}</p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-sm-6">
                                            <span class="gray_label">Transaction ID</span>
                                            <p>{transactionId}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>

    )
}

export default TransactionUnsuccessfull;